import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/travis/build/IBMa/ibm.com-able-v2/able-site/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import { withPrefix } from "gatsby";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h4><strong parentName="h4">{`Level 1`}</strong></h4>
    <ul>
      <li parentName="ul"><a href={withPrefix("toolkit/design/content#input-labels")} target="_blank" rel="noopener noreferrer">Input labels</a></li>
      <li parentName="ul"><a href={withPrefix("toolkit/design/visual/#required-fields")} target="_blank" rel="noopener noreferrer">Required fields</a></li>
    </ul>
    <h4><strong parentName="h4">{`Level 2`}</strong></h4>
    <ul>
      <li parentName="ul"><a href={withPrefix("toolkit/design/content#data-format-for-inputs")} target="_blank" rel="noopener noreferrer">Data format for inputs</a></li>
      <li parentName="ul"><a href={withPrefix("toolkit/design/content#placeholder-text")} target="_blank" rel="noopener noreferrer">Placeholder text</a></li>
    </ul>
    <h4><strong parentName="h4">{`Level 3`}</strong></h4>
    <ul>
      <li parentName="ul"><a href={withPrefix("toolkit/design/visual/#form-inputs")} target="_blank" rel="noopener noreferrer">Form inputs</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      